<div class="overlay" *ngIf="isLoading | async">
	<div class="spinner">
		<div class="spinner-part spinner-part1"></div>
		<div class="spinner-part spinner-part2"></div>
		<img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
	</div>
</div>
<div class="header-container">
	<span>
		<p>
			<!-- <span class="previous-page">Users / </span> <span class="current-page"> Users Bulk Upload</span> -->
		</p>
	</span>
	<div class="button-container">
		<button *ngIf="isOutlet" mat-raised-button routerLink="/suzuki/outlet">
			< Back</button>

		<button *ngIf="!isOutlet" mat-raised-button routerLink="/suzuki/dealer">
			< Back</button>
	</div>
</div>
<div class="container-fluid pl-0">
	<div class="container-upload">
		<div class="title">
			<p class="text-left head-text" *ngIf="isOutlet">Outlets Bulk Upload</p>
			<p class="text-left head-text" *ngIf="!isOutlet">Dealers Bulk Upload</p>
			<p class="text-left sub-head">Upload .csv, xlsx, xls file for bulk upload</p>
		</div>

		<div class="row justify-content-center">
			<div class="col-md-6 col-sm-8 upload-container">
				<div class="mb-3 d-flex justify-content-between align-items-center">
					<label class="form-label mb-0 upload-label">Upload</label>
				</div>

				<!-- Show upload box if no file is selected -->
				<div *ngIf="!uploadedFile" id="uploadBox" class="upload-box" (drop)="onFileDrop($event)"
					(dragover)="onDragOver($event)">
					<img src="/assets/images/backup.png" alt="">
					<p class="mt-2">Drag your file(s) or <span class="text-primary"
							(click)="fileInput.click()">browse</span></p>
					<!-- <p class="text-muted">Max 10 MB files are allowed</p> -->
					<input type="file" #fileInput accept=".xls,.xlsx,.csv" (change)="onFileSelect($event)" hidden>
				</div>

				<!-- Show file details if a file is selected -->
				<div *ngIf="uploadedFile" class="file-details mt-4 mb-4">
					<div class="d-flex justify-content-between align-items-center">
						<span style="color:rgb(11, 93, 187);font-weight: 500;">{{ uploadedFile.name }}</span>
						<div class="d-flex">
							<button class="btn btn-danger btn-sm" (click)="deleteFile()">Delete</button>
							<button class="btn btn-primary btn-sm ml-2" (click)="upload()">Upload</button>
						</div>
					</div>
				</div>

				<p class="text-muted mt-3">Only Support .csv, xlsx, xls</p>
				<!-- <hr class="mt-2">
				<p class="download-file"> Download Sample File</p>
				<div class="d-flex justify-content-between align-items-center sample-file mt-2">
					<span>
            Sample.xlsx
          </span>
					<button class="btn preview" >Submit</button>
				</div> -->
			</div>
		</div>
	</div>
</div>

<ng-template #validationError>
	<h1 mat-dialog-title style="color: #e74f4f;">
		<img src="/assets/images/history-alert.png" alt="" style="margin-right: 3px;margin-bottom: 4px;"> Validation
		Error!
		<img class="close-button" (click)="onClose()" src="/assets/images/close.png" alt="">
	</h1>
	<div mat-dialog-content>
		<div class="table-container">
			<ul>
				<li class="validation-list" *ngFor="let data of validationData">
					{{data}}
				</li>
			</ul>
		</div>
	</div>
	<div mat-dialog-actions class="d-flex justify-content-end">
		<button class="btn white-btn mr-2" (click)="onClose()">Cancel</button>
	</div>
</ng-template>